import { Component } from '@theme/component';

const POSITION_COLLECTIONS = {
  '': '/collections/commercial-tires',
  steer: '/collections/steer-tires',
  drive: '/collections/drive-tires',
  trailer: '/collections/trailer-tires',
};

class TireFinder extends Component {
  requiredRefs = ['size', 'position', 'submit', 'message'];

  connectedCallback() {
    super.connectedCallback();
    const tabs = [...this.querySelectorAll('[data-tab]')];
    for (const button of tabs) {
      button.addEventListener('click', () => this.showTab(button.dataset.tab, false));
    }
    this.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      let next = current;
      if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      this.showTab(tabs[next].dataset.tab, true);
    });
    this.showTab('position');
    this.dataset.ready = '';
  }

  showTab(tab, focusTab = false) {
    for (const button of this.querySelectorAll('[data-tab]')) {
      const selected = button.dataset.tab === tab;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
      button.tabIndex = selected ? 0 : -1;
      if (selected && focusTab) button.focus();
    }
    for (const panel of this.querySelectorAll('[data-panel]')) {
      panel.hidden = panel.dataset.panel !== tab;
    }
  }

  clearMessage() {
    this.refs.message.hidden = true;
  }

  handleSubmit(event) {
    event.preventDefault();
    const { size, position, message } = this.refs;

    if (!size.value && position.value) {
      window.location.assign(POSITION_COLLECTIONS[position.value]);
      return;
    }

    if (!size.value) {
      message.textContent = 'Pick your tire size, or just a position to see every tire for that axle.';
      message.hidden = false;
      size.focus();
      return;
    }

    const base = POSITION_COLLECTIONS[position.value] ?? POSITION_COLLECTIONS[''];
    const tag = `size-${size.value.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    window.location.assign(`${base}/${tag}`);
  }
}

if (!customElements.get('tire-finder')) {
  customElements.define('tire-finder', TireFinder);
}
